import { Button, defaultIconSize } from '@synqo/frontend-component-library';
import { IconCashRegister } from '@tabler/icons-react';

export function TestTseButton({ isTseAvailable, onPing }: { isTseAvailable: boolean; onPing: () => void }) {
    return (
        <Button
            label={isTseAvailable ? 'TSE erreichbar' : 'TSE nicht erreichbar'}
            appearance={isTseAvailable ? 'filled' : 'outlined'}
            onClick={onPing}
        >
            <IconCashRegister size={defaultIconSize} />
        </Button>
    );
}
